<template>
  <div class="map-container columns is-variable is-2">
    <div class="column is-8">
      <div class="box" id="map"></div>
    </div>
    <div class="column is-4">
      <div class="box">
        <div class="columns is-variable is-2">
          <div class="column is-full">
            <p class="title is-size-6" v-if="text.target_title">
              {{ text.target_title }}<small v-if="text.target_info" v-tooltip
                class="has-tooltip-right has-tooltip-multiline tooltip-has-enters"
                :data-tooltip="text.target_info.replace(/;/g, '\u000D\u000A')">
                <font-awesome-icon :size="'xs'" :icon="icons.info" />
              </small>
            </p>
            <div class="tags">
              <a v-for="tag in spis" :key="tag.key" class="tag" @click="SelectActiveFilter(tag.key)"
                :class="{ 'is-primary': activeFilter.includes(tag.key) }">
                <span v-if="targets[tag.name.toLowerCase()]">{{
                  targets[tag.name.toLowerCase()]
                }}</span>
                <span v-else>{{ tag.name.toLowerCase() }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="box" v-if="data">
        <div class="columns is-variable is-2">
          <div class="column is-full">
            <p class="title is-size-6" v-if="text.limit_title">
              {{ text.limit_title }}
            </p>
            <div class="columns">
              <div class="column is-full">
                <p class="title is-size-7 is-pulled-right" v-if="text.total_accidents">
                  {{ text.total_accidents }}
                </p>
                <div class="slider-container">
                  <input id="sliderWithValue" class="slider has-output-tooltip is-fullwidth" :min="minimalValues.total"
                    :max="maximalValues.total" v-model="sliderValues.total" step="1" type="range"
                    @input="SetSliderTooltip('total', $event.target.value)" @change="
                      ClosePopup(true);
                    SetFilters();
                    SetUrlParams();
                                          " />
                  <output for="sliderWithValue" :ref="'total'">{{
                    sliderValues.total
                  }}</output>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-full">
                <p class="title is-size-7 is-pulled-right" v-if="text.victim_accidents">
                  {{ text.victim_accidents }}
                </p>
                <div class="slider-container">
                  <input id="sliderWithValue" class="slider has-output-tooltip is-fullwidth"
                    :min="minimalValues.casualtie" :max="maximalValues.casualtie" v-model="sliderValues.casualtie"
                    step="1" type="range" @input="SetSliderTooltip('casualtie', $event.target.value)" @change="
                      ClosePopup(true);
                    SetFilters();
                    SetUrlParams();
                                          " />
                  <output for="sliderWithValue" :ref="'casualtie'">{{
                    sliderValues.casualtie
                  }}</output>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-full">
                <p class="title is-size-7 is-pulled-right" v-if="text.fatal_accidents">
                  {{ text.fatal_accidents }}
                </p>
                <div class="slider-container">
                  <input id="sliderWithValue" class="slider has-output-tooltip is-fullwidth" :min="minimalValues.fatal"
                    :max="maximalValues.fatal" v-model="sliderValues.fatal" step="1" type="range"
                    @input="SetSliderTooltip('fatal', $event.target.value)" @change="
                      ClosePopup(true);
                    SetFilters();
                    SetUrlParams();
                                          " />
                  <output for="sliderWithValue" :ref="'fatal'">{{
                    sliderValues.fatal
                  }}</output>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box msm" v-if="data && showMsmBanner">
        <img src="/img/msm.png" alt="Mobiel Schade Melden" />
        <a href="https://www.mobielschademelden.nl" rel="nofollow" target="_blank"></a>
      </div>
      <div class="box ab-inbev" v-if="data && showABInBevBanner">
        <img src="/img/ab-inbev.png" alt="AB InBev" />
        <a href="https://ab-inbev.nl" rel="nofollow" target="_blank"></a>
      </div>
    </div>
  </div>
</template>

<script>
import maplibregl from 'maplibre-gl'
import Highcharts from 'highcharts'
import PitchToggle from '@/mixins/pitchtoggle'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'Map',

  props: {
    text: {
      type: Object,
      required: false,
      default: () => { }
    },
    targets: {
      type: Object,
      required: false,
      default: () => { }
    },
    countryCode: {
      type: String,
      default: 'NLD'
    },
    showMsmBanner: {
      type: Boolean,
      default: true
    },
    showABInBevBanner: {
      type: Boolean,
      default: false
    }
  },

  data () {
    var minValues = {
      total: 1,
      casualtie: 0,
      fatal: 0
    }
    return {
      icons: {
        info: faInfoCircle
      },
      country: this.countryCode || this.$store.state.country,
      baseUrl:
        'https://api.' +
        this.$store.state.base +
        '/applications/PublicAccidents',
      map: null,
      pitchtoggle: null,
      initialZoom: 17.8,
      spikey: '',
      minimalValues: {
        total: minValues.total,
        casualtie: minValues.casualtie,
        fatal: minValues.fatal
      },
      sliderValues: {
        total: minValues.total,
        casualtie: minValues.casualtie,
        fatal: minValues.fatal
      },
      activeFilter: [],
      popup: null,
      clicked: [],
      feature: null,
      urlParams: {
        x: 0,
        y: 0,
        z: 0,
        b: 0,
        p: 0,
        t: minValues.total,
        c: minValues.casualtie,
        f: minValues.fatal,
        s: ''
      },
      chartTitles: {
        omd_accidents: this.text.omd_accidents
          ? this.text.omd_accidents
          : false,
        injured_accidents: this.text.injured_accidents
          ? this.text.injured_accidents
          : false,
        fatal_accidents: this.text.fatal_accidents
          ? this.text.fatal_accidents
          : false
      }
    }
  },

  computed: {
    data () {
      return this.$store.state.publicAccidentData
    },
    spis () {
      var tmp = []
      for (const property in this.data.SPIs) {
        tmp.push({ key: property, name: this.data.SPIs[property] })
      }
      return tmp
    },
    maximalValues () {
      if (this.data) {
        return {
          total: this.data.Values['Max' + this.spikey + 'TotalAccidents'],
          casualtie: this.data.Values['Max' + this.spikey + 'VictimAccidents'],
          fatal: this.data.Values['Max' + this.spikey + 'FatalAccidents']
        }
      } else {
        return {}
      }
    }
  },

  beforeDestroy () {
    window.removeEventListener('click', this.WindowClickEvent)
    this.map.remove()
  },

  mounted () {
    var _this = this

    _this.country = _this.countryCode || _this.$store.state.country

    _this.InitUrlParams()
    if (_this.$store.state.publicAccidentData) {
      _this.InitSliders()
      _this.InitMap()
    } else {
      _this.$store.dispatch('getPublicAccidentData', _this.country)
    }
  },

  watch: {
    '$store.state.publicAccidentData': {
      handler: function () {
        if (this.$store.state.publicAccidentData) {
          this.InitSliders()
          this.InitMap()
        }
      },
      immediate: false
    },
    '$store.state.language': {
      handler: function () {
        if (this.$store.state.publicAccidentData) {
          this.InitSliders()
          this.InitMap()
        }
      },
      immediate: false
    },
    '$store.state.dark': {
      handler: function () {
        if (this.$store.state.publicAccidentData) {
          this.InitSliders()
          this.InitMap()
        }
      },
      immediate: false
    }
  },

  methods: {
    InitMap: function () {
      var _this = this

      // var script = document.createElement("script");
      // script.onload = function () {};
      // script.async = true;
      // script.src = "https://unpkg.com/maplibre-gl@1.15.2/dist/maplibre-gl.js";
      // document.head.appendChild(script);

      // maplibregl.accessToken =
      //   'pk.eyJ1IjoiaHVnb2NvcHBlbiIsImEiOiJjazdxOHF6YXQwMWJqM3JvYW5kbzgycmFrIn0.sT-R6a9JL-olMcZRYetbsw'
      _this.map = new maplibregl.Map({
        container: 'map',
        style:
          'https://api.maptiler.com/maps/voyager/style.json?key=vlcW3Y0VUAbek4mbEKF6',
        // style: _this.$store.state.dark
        //   ? 'mapbox://styles/mapbox/dark-v10'
        //   : 'mapbox://styles/mapbox/light-v10',
        attributionControl: true,
        customAttribution: _this.Attribution(),
        center: [
          _this.urlParams.x === 0
            ? _this.data.Values.CenterX
            : _this.urlParams.x,
          _this.urlParams.y === 0
            ? _this.data.Values.CenterY
            : _this.urlParams.y
        ],
        zoom:
          _this.urlParams.z !== 0
            ? _this.urlParams.z
            : _this.data.Values.MaxZoom,
        minZoom: _this.data.Values.MaxZoom,
        bearing: _this.urlParams.b !== 0 ? _this.urlParams.b : 0,
        maxPitch: 0
      })

      _this.pitchtoggle = new PitchToggle({ minpitchzoom: 18 })

      _this.map.addControl(new maplibregl.NavigationControl())
      _this.map.addControl(_this.pitchtoggle)

      _this.map.on('load', function () {
        _this.AddSource()
        _this.CreateGeoLayers()
        _this.BindMapEvents()
        _this.SetFilters()

        if (Number(_this.urlParams.p) !== 0 && _this.urlParams.z >= 12) {
          _this.pitchtoggle.toggle()
          _this.map.setPitch(_this.urlParams.p)
        }

        if (_this.urlParams.s !== '') {
          _this.SelectActiveFilter(_this.urlParams.s)
        }
      })
    },
    InitUrlParams: function () {
      var _this = this
      var hash = window.location.hash.replace(/\s/g, '').substr(1)

      if (hash !== '') {
        var mapParams = hash.split('/')
        if (mapParams.length >= 5) {
          _this.urlParams.x = mapParams[0]
          _this.urlParams.y = mapParams[1]
          _this.urlParams.z = mapParams[2]
          _this.urlParams.b = mapParams[3]
          _this.urlParams.p = mapParams[4]
        }
        if (mapParams.length >= 6) {
          var extraParams = mapParams[5].split(',')
          for (var i = 0; i < extraParams.length; i++) {
            var item = extraParams[i].split('=')
            if (_this.urlParams.hasOwnProperty(item[0]) && item.length === 2) {
              _this.urlParams[item[0]] = item[1]
            }
          }
        }
      }
    },
    SetUrlParams: function () {
      var _this = this
      if (_this.map) {
        var c = _this.map.getCenter()
        var z = _this.map.getZoom().toFixed(4)
        var b = _this.map.getBearing().toFixed(4)
        var p = _this.pitchtoggle.mode === '3d' ? _this.map.getPitch() : 0
        var params = []
        // console.log(_this.spikey)
        if (_this.spikey !== '') {
          params.push(['s', _this.spikey.slice(0, -1)])
        }

        for (var key in _this.sliderValues) {
          if (_this.sliderValues[key] > _this.minimalValues[key]) {
            params.push([key[0], _this.sliderValues[key]])
          }
        }

        var hash =
          c.lng.toFixed(4) +
          '/' +
          c.lat.toFixed(4) +
          '/' +
          z +
          '/' +
          b +
          '/' +
          p
        if (params.length > 0) {
          hash += '/'
          for (var i = 0; i < params.length; i++) {
            if (i !== 0) {
              hash += ','
            }
            hash += params[i][0] + '=' + params[i][1]
          }
        }
        history.replaceState(null, null, '#' + hash)
      } else {
        history.replaceState(null, null, '')
      }
    },
    InitSliders: function () {
      var _this = this
      _this.$nextTick(function () {
        for (var key in _this.sliderValues) {
          if (_this.urlParams[key[0]]) {
            var value = Number(_this.urlParams[key[0]])
            if (
              value !== 0 &&
              value >= _this.minimalValues[key] &&
              value < _this.maximalValues[key]
            ) {
              _this.sliderValues[key] = value
            }
          }
          _this.SetSliderTooltip(key, _this.sliderValues[key])
        }
      })
    },
    Attribution: function () {
      const year = new Date().getFullYear()
      return '<span>© ' + year + ' VIA</span>'
    },

    BindMapEvents: function () {
      var _this = this
      _this.map.on('click', function (e) {
        _this.SetDetailData(null)
        _this.ClosePopup(true)

        if (_this.map.getZoom() >= 9) {
          _this.SetDetailData(e)
          _this.GetDetailData()
        }
      })
      _this.map.on('moveend', function () {
        _this.SetUrlParams()
      })

      window.addEventListener('click', _this.WindowClickEvent)
    },

    WindowClickEvent: function (e) {
      if (e.target.classList.contains('maplibregl-popup-close-button')) {
        this.ClosePopup(true)
      }
    },

    AddSource: function () {
      this.map.addSource('public', {
        type: 'vector',
        tiles: [
          this.baseUrl + '/' + this.country + '/Tile/{z}/{x}/{y}'
        ],
        buffer: 1,
        minzoom: 3,
        maxzoom: 14,
        generateId: true
      })
    },

    CreateGeoLayers: function () {
      this.map.addLayer({
        id: 'omd_accidents',
        type: 'fill-extrusion',
        source: 'public',
        minzoom: 12,
        layout: {
          visibility: 'none'
        },
        paint: {
          'fill-extrusion-color': this.$store.state.dark
            ? 'rgb(56, 246, 252)'
            : 'rgb(110,195,198)',
          'fill-extrusion-vertical-gradient': this.$store.state.dark,
          'fill-extrusion-opacity': 1
        },

        'source-layer': 'poly'
      })
      this.map.addLayer({
        id: 'injured_accidents',
        type: 'fill-extrusion',
        source: 'public',
        minzoom: 12,
        layout: {
          visibility: 'none'
        },
        paint: {
          'fill-extrusion-color': this.$store.state.dark
            ? 'rgb(252, 160, 56)'
            : 'rgb(226,97,99)',
          'fill-extrusion-vertical-gradient': this.$store.state.dark,
          'fill-extrusion-opacity': 1
        },
        'source-layer': 'poly'
      })
      this.map.addLayer({
        id: 'fatal_accidents',
        type: 'fill-extrusion',
        source: 'public',
        minzoom: 12,
        layout: {
          visibility: 'none'
        },
        paint: {
          'fill-extrusion-color': this.$store.state.dark
            ? 'rgb(252, 62, 56)'
            : 'rgb(63,17,21)',
          'fill-extrusion-vertical-gradient': this.$store.state.dark,
          'fill-extrusion-opacity': 1
        },
        'source-layer': 'poly'
      })

      this.map.addLayer({
        id: 'total_accidents',
        type: 'circle',
        source: 'public',
        paint: {
          'circle-color': this.$store.state.dark
            ? 'rgb(56, 246, 252)'
            : 'rgb(110,195,198)'
        },
        'source-layer': 'point'
      })

      this.map.addLayer({
        id: 'casualtie_accidents',
        type: 'circle',
        source: 'public',
        paint: {
          'circle-color': this.$store.state.dark
            ? 'rgb(252, 160, 56)'
            : 'rgb(226,97,99)'
        },
        'source-layer': 'point'
      })

      this.map.addLayer({
        id: 'point_fatal_accidents',
        type: 'circle',
        source: 'public',
        paint: {
          'circle-color': this.$store.state.dark
            ? 'rgb(252, 62, 56)'
            : 'rgb(63,17,21)'
        },
        'source-layer': 'point'
      })
    },
    getSpiFilet: function (result) {
      result.push([
        '>=',
        [
          '+',
          [
            '+',
            ['to-number', ['get', this.spikey + 'omd_accidents']],
            ['to-number', ['get', this.spikey + 'injured_accidents']]
          ],
          ['to-number', ['get', this.spikey + 'fatal_accidents']]
        ],
        +this.sliderValues.total
      ])
      result.push([
        '>=',
        [
          '+',
          ['to-number', ['get', this.spikey + 'injured_accidents']],
          ['to-number', ['get', this.spikey + 'fatal_accidents']]
        ],
        +this.sliderValues.casualtie
      ])
      result.push([
        '>=',
        ['to-number', ['get', this.spikey + 'fatal_accidents']],
        +this.sliderValues.fatal
      ])
      return result
    },
    getFilter: function (add) {
      const result = ['all', add]
      return this.getSpiFilet(result)
    },
    getInterpolate: function (value, correction) {
      return [
        'interpolate',
        ['linear'],
        ['zoom'],
        6,
        [
          'interpolate',
          ['linear'],
          ['*', 0.1, value],
          0,
          1,
          10,
          10,
          20,
          14 + correction
        ],
        16,
        ['interpolate', ['linear'], value, 0, 2, 10, 10, 20, 14 + correction]
      ]
    },
    SetDetailData: function (e) {
      // console.log(e)
      this.clicked = e

      if (this.clicked) {
        var bbox = [
          [e.point.x - 5, e.point.y - 5],
          [e.point.x + 5, e.point.y + 5]
        ]

        const features = this.map.queryRenderedFeatures(bbox, {
          layers: [
            'total_accidents',
            'omd_accidents',
            'injured_accidents',
            'fatal_accidents',
            'casualtie_accidents',
            'point_fatal_accidents'
          ]
        })

        if (features.length > 0) {
          this.feature = features[0]
          if (
            this.feature._vectorTileFeature &&
            this.feature._vectorTileFeature.properties &&
            Object.keys(this.feature._vectorTileFeature.properties).length > 0
          ) {
            var found = false
            for (var key in this.feature._vectorTileFeature.properties) {
              if (key.indexOf(this.spikey) === 0) {
                found = true
                break
              }
            }
            if (!found) {
              this.feature = null
              this.clicked = null
            }
          }
        }
      } else {
        this.feature = null
      }
    },
    GetDetailData: function () {
      var _this = this
      if (_this.feature) {
        _this.OpenPopup()
        var url =
          '/PublicAccidents/' +
          _this.country +
          '/' +
          _this.feature.id
        if (_this.spikey) {
          url += '?spi=' + _this.spikey.slice(0, -1)
        }
        _this
          .$http({
            method: 'GET',
            url: url,
            api: 'applications',
            auth: false
          })
          .then(function (response) {
            if (_this.popup) {
              _this.SetPopupChart(response.data)
            }
          })
      }
    },
    OpenPopup: function () {
      var _this = this
      if (_this.feature) {
        _this.popup = new maplibregl.Popup()
          .setLngLat(_this.GetFeatureCenter(_this.feature))
          .setHTML('<div id="popupcontent"></div>')
          // .on('close', function (e) {
          //   console.log(e)
          // })
          .addTo(_this.map)
      }
    },
    ClosePopup: function (removeHistory) {
      var _this = this
      removeHistory = removeHistory || false
      if (_this.popup) {
        _this.popup.remove()
      }
      if (removeHistory) {
        _this.clicked = null
      }
    },
    SetPopupChart: function (data) {
      var titles = {
        omd_accidents: this.chartTitles.omd_accidents || data.Data[0].Title,
        injured_accidents:
          this.chartTitles.injured_accidents || data.Data[1].Title,
        fatal_accidents: this.chartTitles.fatal_accidents || data.Data[2].Title
      }
      Highcharts.chart('popupcontent', {
        chart: {
          reflow: true,
          type: 'column'
        },
        credits: {
          enabled: false
        },
        title: null,
        xAxis: {
          categories: data.Labels.split(',').map(function (i) {
            return i.replace(/"/g, '')
          }),
          labels: {
            style: {
              fontSize: '9px'
            },
            rotation: 0
          }
        },
        yAxis: {
          allowDecimals: false,
          min: 0,
          title: {
            text: null
          },
          labels: {
            style: {
              fontSize: '9px'
            }
          }
        },
        legend: { enabled: false },
        plotOptions: {
          series: {
            cursor: 'pointer',
            marker: {
              states: {
                select: {
                  lineColor: false,
                  lineWidth: false,
                  fillColor: false
                }
              }
            }
          },
          column: {
            stacking: 'normal'
          }
        },
        series: [
          {
            name: titles.fatal_accidents, // data.Data[2].Title,
            type: 'column',
            color: this.$store.state.dark
              ? 'rgb(252, 62, 56)'
              : 'rgb(63,17,21)',
            data: data.Data[2].Data
          },
          {
            name: titles.injured_accidents, // data.Data[1].Title,
            type: 'column',
            color: this.$store.state.dark
              ? 'rgb(252, 160, 56)'
              : 'rgb(226,97,99)',
            data: data.Data[1].Data
          },
          {
            name: titles.omd_accidents, // data.Data[0].Title,
            type: 'column',
            color: this.$store.state.dark
              ? 'rgb(56, 246, 252)'
              : 'rgb(110,195,198)',
            data: data.Data[0].Data
          }
        ]
      })
    },
    GetFeatureCenter: function (feature) {
      let center = []
      let latitude = 0
      let longitude = 0
      let coordinates = []

      if (feature.geometry.type === 'Point') {
        center = feature.geometry.coordinates
      } else {
        feature.geometry.coordinates.forEach(function (c) {
          let dupe = []
          if (feature.geometry.type === 'MultiPolygon') dupe.push(...c[0])
          else dupe.push(...c)
          dupe.splice(-1, 1)
          coordinates = coordinates.concat(dupe)
        })
        coordinates.forEach(function (c) {
          latitude += c[0]
          longitude += c[1]
        })
        center = [
          latitude / coordinates.length,
          longitude / coordinates.length
        ]
      }

      return center
    },
    SetSliderTooltip: function (key, value) {
      var newPoint =
        (value - this.minimalValues[key]) /
        (this.maximalValues[key] - this.minimalValues[key])
      this.$refs[key].style.marginLeft =
        '-' + this.$refs[key].offsetWidth / 2 + 'px'
      this.$refs[key].style.left = newPoint * 100 + '%'
    },
    SelectActiveFilter: function (active) {
      const idx = this.activeFilter.indexOf(active)
      if (idx > -1) {
        this.activeFilter.splice(idx, 1)
        this.spikey = ''
      } else {
        this.activeFilter.splice(0, this.activeFilter.length)
        this.activeFilter.push(active)
        this.spikey = `${active}_`
      }
      for (var key in this.sliderValues) {
        if (this.sliderValues[key] > this.maximalValues[key]) {
          this.sliderValues[key] = this.maximalValues[key]
        } else if (this.sliderValues[key] < this.minimalValues[key]) {
          this.sliderValues[key] = this.minimalValues[key]
        }
        this.SetSliderTooltip(key, this.sliderValues[key])
      }

      this.ClosePopup(false)
      // console.log(typeof this.clicked)
      if (
        this.map.getZoom() >= 9 &&
        this.clicked &&
        Object.keys(this.clicked).length > 0
      ) {
        this.SetDetailData(this.clicked)
        this.GetDetailData()
      }

      this.SetUrlParams()
      this.SetFilters()
    },
    SetFilters: function () {
      this.map.setFilter(
        'omd_accidents',
        this.getFilter([
          '>',
          ['to-number', ['get', this.spikey + 'omd_accidents']],
          0
        ])
      )
      this.map.setPaintProperty('omd_accidents', 'fill-extrusion-height', [
        'interpolate',
        ['linear'],
        ['zoom'],
        1,
        ['*', 200, ['to-number', ['get', this.spikey + 'omd_accidents']]],
        13.05,
        ['*', 5, ['to-number', ['get', this.spikey + 'omd_accidents']]]
      ])

      this.map.setFilter(
        'injured_accidents',
        this.getFilter([
          '>',
          ['to-number', ['get', this.spikey + 'injured_accidents']],
          0
        ])
      )
      this.map.setPaintProperty('injured_accidents', 'fill-extrusion-height', [
        'interpolate',
        ['linear'],
        ['zoom'],
        1,
        [
          '+',
          ['*', 200, ['to-number', ['get', this.spikey + 'omd_accidents']]],
          ['*', 200, ['to-number', ['get', this.spikey + 'injured_accidents']]]
        ],
        13.05,
        [
          '+',
          ['*', 5, ['to-number', ['get', this.spikey + 'omd_accidents']]],
          ['*', 5, ['to-number', ['get', this.spikey + 'injured_accidents']]]
        ]
      ])
      this.map.setPaintProperty('injured_accidents', 'fill-extrusion-base', [
        'interpolate',
        ['linear'],
        ['zoom'],
        10,
        0,
        10.05,
        ['*', 5, ['to-number', ['get', this.spikey + 'omd_accidents']]]
      ])

      this.map.setFilter(
        'fatal_accidents',
        this.getFilter([
          '>',
          ['to-number', ['get', this.spikey + 'fatal_accidents']],
          0
        ])
      )
      this.map.setPaintProperty('fatal_accidents', 'fill-extrusion-height', [
        'interpolate',
        ['linear'],
        ['zoom'],
        1,
        [
          '+',
          [
            '+',
            ['*', 200, ['to-number', ['get', this.spikey + 'omd_accidents']]],
            [
              '*',
              200,
              ['to-number', ['get', this.spikey + 'injured_accidents']]
            ]
          ],
          ['*', 200, ['to-number', ['get', this.spikey + 'fatal_accidents']]]
        ],
        13.05,
        [
          '+',
          [
            '+',
            ['*', 5, ['to-number', ['get', this.spikey + 'omd_accidents']]],
            ['*', 5, ['to-number', ['get', this.spikey + 'injured_accidents']]]
          ],
          ['*', 5, ['to-number', ['get', this.spikey + 'fatal_accidents']]]
        ]
      ])

      this.map.setPaintProperty('fatal_accidents', 'fill-extrusion-base', [
        'interpolate',
        ['linear'],
        ['zoom'],
        10,
        0,
        10.05,
        [
          '+',
          ['*', 5, ['to-number', ['get', this.spikey + 'omd_accidents']]],
          ['*', 5, ['to-number', ['get', this.spikey + 'injured_accidents']]]
        ]
      ])

      this.map.setFilter(
        'total_accidents',
        this.getFilter([
          '>',
          [
            '+',
            [
              '+',
              ['to-number', ['get', this.spikey + 'omd_accidents']],
              ['to-number', ['get', this.spikey + 'injured_accidents']]
            ],
            ['to-number', ['get', this.spikey + 'fatal_accidents']]
          ],
          0
        ])
      )
      this.map.setPaintProperty(
        'total_accidents',
        'circle-radius',
        this.getInterpolate(
          [
            '+',
            [
              '+',
              ['to-number', ['get', this.spikey + 'omd_accidents']],
              ['to-number', ['get', this.spikey + 'injured_accidents']]
            ],
            ['to-number', ['get', this.spikey + 'fatal_accidents']]
          ],
          0
        )
      )

      this.map.setFilter(
        'casualtie_accidents',
        this.getFilter([
          '>',
          [
            '+',
            ['to-number', ['get', this.spikey + 'injured_accidents']],
            ['to-number', ['get', this.spikey + 'fatal_accidents']]
          ],
          0
        ])
      )
      this.map.setPaintProperty(
        'casualtie_accidents',
        'circle-radius',
        this.getInterpolate(
          [
            '+',
            ['to-number', ['get', this.spikey + 'injured_accidents']],
            ['to-number', ['get', this.spikey + 'fatal_accidents']]
          ],
          -1
        )
      )

      this.map.setFilter(
        'point_fatal_accidents',
        this.getFilter([
          '>',
          ['to-number', ['get', this.spikey + 'fatal_accidents']],
          0
        ])
      )
      this.map.setPaintProperty(
        'point_fatal_accidents',
        'circle-radius',
        this.getInterpolate(
          ['to-number', ['get', this.spikey + 'fatal_accidents']],
          -2
        )
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  &.msm, &.ab-inbev {
    position: relative;
    padding: 0;
    line-height: 0;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
    }

    >a {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  &.ab-inbev{
    padding: 10px;
  }

  .slider-container {
    position: relative;
    padding-top: 20px;
    margin: 10px 7px 0px 7px;

    >input {
      margin: 0;
      margin-left: -7px;
      width: calc(100% + 14px);
    }

    >output {
      overflow: visible !important;
      width: 26px !important;
      padding: 0.2rem 0rem !important;
      top: 2px !important;
      line-height: 0.85rem !important;

      &:after {
        content: "";
        border-style: solid;
        border-width: 3px;
        border-color: transparent;
        border-top-color: $grey-dark;
        position: absolute;
        height: 0px;
        width: 0px;
        left: calc(50% - 3px);
        top: 100%;
      }
    }
  }
}

#map {
  // height: 100%;
  height: 600px;
  // Sky color
  background-color: aliceblue;
  padding: 0px;

  /deep/.mapboxgl-canvas-container {
    canvas:focus {
      outline: none;
    }
  }

  /deep/.mapboxgl-control-container {
    .mapboxgl-ctrl-attrib-button,
    .mapboxgl-ctrl-bottom-left {
      display: none !important;
    }

    .mapboxgl-ctrl-group {

      .mapboxgl-ctrl-pitchtoggle-3d,
      .mapboxgl-ctrl-pitchtoggle-2d {
        strong {
          color: #000000;
        }

        &.disabled {
          opacity: 0.25;
          cursor: not-allowed;
        }
      }
    }

    .mapboxgl-ctrl-attrib {
      padding: 0 5px;
      background-color: transparentize($white, 0.2);
      margin: 0;
      border-radius: 0px;
      min-height: 15px;

      .mapboxgl-ctrl-attrib-inner {
        height: 20px;
        overflow: hidden;
        display: block;

        >span {
          font-family: $font-family;
        }
      }
    }
  }

  /deep/.mapboxgl-popup-content {
    width: 245px;
    height: 160px;
    padding: 10px 10px;

    #popupcontent {
      height: 150px;
      width: 225px;
    }
  }
}
</style>
